import { createAction, props } from '@ngrx/store';
import { TokenResponse } from 'assurcard-angular-library';
import { TokenResponseModel } from 'src/app/authenticator/models';

export const loginLight = createAction(
  '[Authentication] Login light',
);

export const loginLightSuccess = createAction(
  '[Authentication] Login light success',
  props<{ data: TokenResponseModel }>()
);

export const loginLightFailure = createAction(
  '[Authentication] Login light failure',
  props<{ data: any }>()
);


export const getFullAccess = createAction(
  '[Authentication] Get full access',
  props<{ insurerId: string, cardId: string, dob: string}>()
);

export const getFullAccessSuccess = createAction(
  '[Authentication] Get full access success',
  props<{ token: TokenResponseModel }>()
);

export const getFullAccessFailure = createAction(
  '[Authentication] Get full access failure',
  props<{ data: any }>()
);

export const loginWithCertificate = createAction(
  '[Authentication] Login with certificate',
);

export const loginWithCertificateSuccess = createAction(
  '[Authentication] Login with certificate success',
  props<{ data: TokenResponseModel }>()
);

export const loginWithCertificateFailure = createAction(
  '[Authentication] Login with certificate failure',
  props<{ data: any }>()
);
export const setKioskSite = createAction('[Authentication] Set kiosk site', props<{ token: TokenResponseModel }>());
export const setKioskSiteSuccess = createAction('[Authentication] Set kiosk site success');
export const setKioskSiteFailure = createAction('[Authentication] Set kiosk site failure');

export const resetAuthentication = createAction("[Authentication] Reset");
